export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('c-main-nav__mobile-button--active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });

  // Sticky Nav

  var main_header_top = $(".c-main-header").offset().top;
  var sticky_nav_top = parseInt(main_header_top) + parseInt($(".c-main-header").height());

  var stick_nav = function() {
    var scroll_top = $(window).scrollTop();

    if (scroll_top > sticky_nav_top) {
      $(".js-main-header").addClass("js-header-sticky");
    } else {
      $(".js-main-header").removeClass("js-header-sticky");
    }
  }

  $('.c-main-nav__items').height(parseInt($(window).height()) - 90);
  stick_nav();
  
  $(window).scroll(function () {
    stick_nav();
  });

  $(window).resize(function () {
    $('.c-main-nav__items').height(parseInt($(window).height()) - 90);
  });
}
